export default {"src":"/_next/static/media/fraizer_week.b2b9a047.svg","height":54,"width":255,"blurWidth":0,"blurHeight":0};